import { Download, X, Package, Bus, School } from "lucide-react";
import { Button } from "@/components/ui/button";

const BROCHURES = [
  {
    type: "school",
    title: "School ERP",
    description: "Attendance, fees, grades & more",
    icon: School,
    iconBg: "bg-blue-100",
    iconColor: "text-blue-600",
    href: "https://linkly.link/2ZcPD",
  },
  {
    type: "inventory",
    title: "Inventory",
    description: "Stock management & tracking",
    icon: Package,
    iconBg: "bg-green-100",
    iconColor: "text-green-600",
    href: "https://drive.google.com/file/d/1048QYpo952NXDzeaiW9my97TxSjMMtcF/view?usp=sharing",
  },
  {
    type: "bus",
    title: "Bus Management",
    description: "Route tracking & attendance",
    icon: Bus,
    iconBg: "bg-orange-100",
    iconColor: "text-orange-600",
    href: "https://drive.google.com/file/d/1B4NwZl1ffQcf6sN9AOrU69BmPV7-aeZh/view?usp=sharing",
  },
];

export default function BrochureModal({ onClose }) {
  const handleDownload = (brochure) => {
    window.open(brochure.href, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-5">
          <div>
            <h2 className="text-lg font-bold text-gray-900">Download Brochure</h2>
            <p className="text-sm text-gray-500 mt-0.5">Choose a brochure to download</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex flex-col gap-3">
          {BROCHURES.map((brochure) => {
            const Icon = brochure.icon;
            return (
              <button
                key={brochure.type}
                onClick={() => handleDownload(brochure)}
                className="flex items-center gap-4 p-4 rounded-xl border border-gray-200 hover:border-blue-300 hover:bg-blue-50/50 transition-all text-left group"
              >
                <div className={`w-11 h-11 rounded-xl ${brochure.iconBg} flex items-center justify-center flex-shrink-0`}>
                  <Icon className={`w-5 h-5 ${brochure.iconColor}`} />
                </div>
                <div className="flex-1">
                  <div className="font-semibold text-gray-900 text-sm">{brochure.title}</div>
                  <div className="text-xs text-gray-500 mt-0.5">{brochure.description}</div>
                </div>
                <Download className="w-4 h-4 text-gray-400 group-hover:text-blue-500 transition-colors" />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
